import { ValueOf } from 'type-fest'
import { nodeThemeConfig } from '@/context/const'
import { useMainStore } from '@/store/index'
export const ThemeSkinType = nodeThemeConfig.ThemeSkinType
export type ThemeSkinType = ValueOf<typeof ThemeSkinType>
export default class LinkResource {
  /**
   * 获取皮肤类型
   * @returns {ThemeSkinType}
   */
  public static get skinType(): ThemeSkinType {
    return (useMainStore().siteInfos?.type ??
      ThemeSkinType.NORMAL) as ThemeSkinType
  }

  public static toSubPageList: Set<ThemeSkinType> = new Set([
    ThemeSkinType.THEME_33,
    ThemeSkinType.THEME_17
  ])

  public static get isToSubPage(): boolean {
    return this.toSubPageList.has(this.skinType)
  }
}
